import classNames from 'classnames'
import { motion } from 'framer-motion'
import { useMemo } from 'react'

import { generateRandomString } from '../helpers'
import styles from './DotCircle.module.scss'

interface Props {
  dotPosition: 1 | 2 | 3 | 4 | 5
  pageIndex: number
  visible?: boolean
}

export const DotCircle = ({ dotPosition, visible, pageIndex }: Props) => {
  const randomString = useMemo(() => generateRandomString(5), [])
  const rotationCompensation = (-90 * (pageIndex + 1)) % 360

  return (
    <motion.div
      className={classNames([
        styles.dot,
        styles[`dot${dotPosition}`],
        styles[`dot${dotPosition}_animated`],
      ])}
      animate={{
        rotate: rotationCompensation,
      }}
      transition={{
        duration: 0.3,
        ease: 'easeInOut',
      }}
    >
      <div
        className={classNames([
          styles['dot-text'],
          visible && styles['dot-text_visible'],
          styles[`dot${dotPosition}__text`],
        ])}
      >
        {randomString}
      </div>
    </motion.div>
  )
}
